/* ============================================================
   Petronella's — wishlist ("Save for later"), localStorage-based.
   No app, no account. Loaded globally from theme.liquid.

   Heart buttons carry: data-wish + data-id, data-variant, data-multivariant,
   data-title, data-url, data-price, data-image, data-meta, data-mood.
   The header heart (data-wishlist-open) opens a slide-out drawer; the same
   render also fills the /pages/wishlist page if it exists. Any container with
   [data-wishlist-view] gets its .wl-grid / .wl-empty / .wl-hero / .wl-sub
   populated, so page + drawer share one renderer.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'petronella_wish_v1';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    renderCount(); sync();
    window.dispatchEvent(new CustomEvent('wish:change', { detail: list }));
  }
  function has(id) { return read().some(function (i) { return String(i.id) === String(id); }); }
  function remove(id) { write(read().filter(function (i) { return String(i.id) !== String(id); })); }
  function clear() { write([]); }
  function toggle(item) {
    var list = read();
    var idx = list.findIndex(function (i) { return String(i.id) === String(item.id); });
    if (idx > -1) { list.splice(idx, 1); write(list); return false; }
    list.push(item); write(list); return true;
  }

  function itemFromButton(btn) {
    return {
      id: btn.getAttribute('data-id'),
      variant: btn.getAttribute('data-variant') || '',
      multivariant: btn.getAttribute('data-multivariant') === 'true',
      title: btn.getAttribute('data-title') || '',
      url: btn.getAttribute('data-url') || '',
      price: btn.getAttribute('data-price') || '',
      image: btn.getAttribute('data-image') || '',
      meta: btn.getAttribute('data-meta') || '',
      mood: btn.getAttribute('data-mood') || '',
      // optional label for items that aren't a buyable variant (e.g. gift sets,
      // which link to a collection rather than a single product)
      cta: btn.getAttribute('data-cta') || ''
    };
  }

  function renderCount() {
    var n = read().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
    document.querySelectorAll('[data-wish-link]').forEach(function (el) { el.classList.toggle('has-items', n > 0); });
  }

  function sync() {
    document.querySelectorAll('[data-wish]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-id'));
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('title', on ? 'Saved — tap to remove' : 'Save to wishlist');
    });
  }

  // delegated heart clicks
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(itemFromButton(btn));
  });

  window.PetWish = { read: read, write: write, has: has, toggle: toggle, remove: remove, clear: clear,
    count: function () { return read().length; }, open: openDrawer, close: closeDrawer };

  function init() { renderCount(); sync(); renderViews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('wish:change', function () { renderViews(); });

  /* ---------- drawer open / close ---------- */
  function openDrawer() {
    var d = document.querySelector('.wl-drawer');
    if (!d) return false;
    renderViews();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wl-drawer-open');
    return true;
  }
  function closeDrawer() {
    var d = document.querySelector('.wl-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wl-drawer-open');
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-wishlist-open]');
    if (open) { if (openDrawer()) e.preventDefault(); return; }
    if (e.target.closest('[data-wishlist-close]')) { e.preventDefault(); closeDrawer(); return; }

    var rm = e.target.closest('[data-rm]');
    if (rm && rm.closest('.wl-grid')) { e.preventDefault(); remove(rm.getAttribute('data-rm')); return; }
    if (e.target.closest('[data-wl-clear]')) { e.preventDefault(); clear(); return; }

    var addAll = e.target.closest('[data-wl-addall]');
    if (addAll) {
      e.preventDefault();
      var addable = read().filter(function (i) { return i.variant && !i.multivariant; });
      if (!addable.length) { window.location = CART_URL; return; }
      addAll.setAttribute('disabled', 'disabled');
      addAll.textContent = 'Adding…';
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: addable.map(function (i) { return { id: Number(i.variant), quantity: 1 }; }) })
      }).then(function () { window.location = CART_URL; }).catch(function () { window.location = CART_URL; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- render every wishlist view (drawer + page) ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function heartSvg() {
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 20s-7-4.6-7-9.4A3.6 3.6 0 0 1 12 7a3.6 3.6 0 0 1 7 3.6C19 15.4 12 20 12 20Z"/></svg>';
  }
  function coverHtml(it) {
    if (it.image) return '<img class="wl-card__img" src="' + esc(it.image) + '" alt="' + esc(it.title) + '" loading="lazy">';
    return '<div class="wl-card__img wl-card__img--ph">' + esc(it.title) + '</div>';
  }
  function ctaHtml(it) {
    if (it.multivariant || !it.variant) {
      return '<a class="btn btn--coral" href="' + esc(it.url) + '">' + esc(it.cta || 'Choose options') + '</a>';
    }
    return '<form class="wl-add" action="' + ROOT + 'cart/add" method="post">' +
      '<input type="hidden" name="id" value="' + esc(it.variant) + '">' +
      '<button type="submit" class="btn btn--coral">Add to bag</button></form>';
  }
  function cardHtml(it) {
    return '<article class="wl-card">' +
      '<div class="wl-card__cv">' +
        '<a href="' + esc(it.url) + '">' + coverHtml(it) + '</a>' +
        '<button class="card-wish is-saved" data-rm="' + esc(it.id) + '" aria-label="Remove from wishlist" title="Remove from wishlist">' + heartSvg() + '</button>' +
      '</div>' +
      (it.mood ? '<span class="wl-card__mood">' + esc(it.mood) + '</span>' : '') +
      '<a class="wl-card__tl" href="' + esc(it.url) + '"><div class="wl-card__t">' + esc(it.title) + '</div></a>' +
      (it.meta ? '<div class="wl-card__m">' + esc(it.meta) + '</div>' : '') +
      '<div class="wl-card__row"><span class="wl-card__p">' + esc(it.price) + '</span></div>' +
      ctaHtml(it) +
      '<button class="wl-remove" data-rm="' + esc(it.id) + '">Remove</button>' +
    '</article>';
  }

  function renderViews() {
    var views = document.querySelectorAll('[data-wishlist-view]');
    if (!views.length) return;
    var items = read();
    views.forEach(function (view) {
      var grid = view.querySelector('.wl-grid');
      if (!grid) return;
      var empty = view.querySelector('.wl-empty');
      var hero = view.querySelector('.wl-hero');
      var sub = view.querySelector('.wl-sub');
      if (!items.length) {
        grid.innerHTML = '';
        if (empty) empty.classList.remove('hide');
        if (hero) hero.classList.add('hide');
        return;
      }
      if (empty) empty.classList.add('hide');
      if (hero) hero.classList.remove('hide');
      if (sub) sub.textContent = items.length + (items.length === 1 ? ' thing' : ' things') + " you've saved for later";
      grid.innerHTML = items.map(cardHtml).join('');
    });
  }
})();
